import { render, staticRenderFns } from "./Contact4.vue?vue&type=template&id=c4c18dee"
import script from "./Contact4.vue?vue&type=script&lang=js"
export * from "./Contact4.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports